import React from 'react';
import v from 'vudu';
import copy from 'constants/copy';
import Text from 'components/Text';
import { classes as c, colors, format as f, breakpoints } from 'stylesheet';
import SocialButton from 'components/SocialButton';
import Frame from 'components/svgs/Frame';
import { Link } from 'react-router-dom';

const localClasses = v({
  qualifyView: {
    'a': { textDecoration: 'none' },
    padding: '0 20px',
  },
  hero: {
    maxWidth: '500px',
    textAlign: 'center',
    margin: '120px auto 60px auto',
    borderBottom: `1px solid ${colors.taupe}`,
  },
  body: {
    maxWidth: '600px',
    textAlign: 'center',
    margin: '0 auto 120px auto',
  },
  padRightMed: {
    [breakpoints.md]: {
      paddingRight: '1rem'
    }
  },
  padLeftMed: {
    [breakpoints.md]: {
      paddingLeft: '1rem'
    }
  },
  ctaWrapper: {
    position: 'fixed',
    width: '100%',
    bottom: 0,
    backgroundColor: '#10ABF2',
    left: 0,
    backgroundImage: 'linear-gradient(-220deg, #10ABF2 0%, #5E57FE 100%)'
  },
  cta: {
    maxWidth: '400px',
    textAlign: 'center',
    margin: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: '1rem',
    paddingBottom: '1rem',
    'svg': {
      marginLeft: '20px'
    }
  }
});

export default props => {
  return (
    <section className={localClasses.qualifyView}>
      <div className={localClasses.hero}>
        <Text variant={'headline'} color={'white'}>{copy.qualifyView.heading}</Text>
        <Text variant={'subheadline'} color={'taupe'} classes={c.pb3}>{copy.qualifyView.subheading}</Text>
      </div>

      <div className={f(localClasses.body, c.clearfix)}>
        <div className={f(c.col12, c.mdCol6, c.left, localClasses.padRightMed)}>
          <SocialButton variant={'twitter'} active={props.twitterShared} onClick={props.triggerTwitterShare} />
          <div className={f(c.center, c.mb4)}>
            <Text variant={'shareCount'}>1.2k</Text>
            <Text variant={'shareDesc'}>Shares</Text>
          </div>
        </div>
        <div className={f(c.col12, c.mdCol6, c.left, localClasses.padLeftMed)}>
          <SocialButton active={props.facebookShared} onClick={props.triggerFacebookShare} />
          <div className={f(c.center, c.mb4)}>
            <Text variant={'shareCount'}>3.5k</Text>
            <Text variant={'shareDesc'}>Shares</Text>
          </div>
        </div>
      </div>

      <Link to='/bonus'>
        <div className={localClasses.ctaWrapper}>
          <div className={localClasses.cta}>
            <Text variant={'smallTracked'}>Claim My Entry Prize</Text>
            <Frame />
          </div>
        </div>
      </Link>
    </section>
  )
}



// WEBPACK FOOTER //
// ./src/views/QualifyView.js